import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { SessionService } from '../../shared/services/session.service';

export const SelectDateGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const router: Router = inject(Router);
    const session: SessionService = inject(SessionService);
    if (session.location) {
        return true;
    }
    let params:any = {};
    for (let key in route.queryParams) {
        params[key] = route.queryParams[key];
    }
    router.navigate(['/schedule-interview/location'], {queryParams: params});
    return false;
};
